var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBagClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 6H20.825C21.3775 6 21.825 6.4475 21.825 7V15.5837C21.825 16.6875 20.9288 17.5837 19.825 17.5837H7.25C6.14625 17.5837 5.25 16.6875 5.25 15.5837V7C5.25 6.4475 5.6975 6 6.25 6Z",
    fill: "#A0A4AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.25H11C9.895 2.25 9 3.145 9 4.25V6.25H11.25V4.5H15.75V6.25H18V4.25C18 3.145 17.105 2.25 16 2.25Z",
    fill: "#A0A4AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29576 21.5002C9.94466 21.5002 12.092 19.3529 12.092 16.704C12.092 14.0551 9.94466 11.9077 7.29576 11.9077C4.64687 11.9077 2.49951 14.0551 2.49951 16.704C2.49951 19.3529 4.64687 21.5002 7.29576 21.5002Z",
    fill: "#FFC22A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16943 14.2603V16.894L8.24443 17.9853",
    stroke: "white",
    strokeWidth: 1.74792,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBagClock);
export default __webpack_public_path__ + "static/media/icon_bag_clock.b9368ed9.svg";
export { ForwardRef as ReactComponent };